export const seniorBusinessConsultantResume = `
【職務概要】
経営コンサルタントとして13年にわたり、企業再生、事業戦略策定、M&A、事業承継の分野で多様な業界の企業を支援してきました。主に中堅・中小企業の経営課題解決に注力し、財務改善から組織改革、事業拡大戦略まで、経営全般にわたるコンサルティングを提供しています。

特に強みとしているのは、財務分析に基づいた事業戦略の策定と実行支援です。単なる理論やフレームワークの適用ではなく、クライアント企業の現場に入り込み、経営者と二人三脚で戦略を実行に移す 伴走型コンサルティング を得意としています。また、DXを活用した業務効率化や新規事業創出においても豊富な実績を有しています。

近年は製造業のデジタルトランスフォーメーションや事業再構築支援を中心に活動しており、業界の構造変化や技術革新への対応を経営戦略に組み込む支援を行っています。複数の再生案件で『V字回復』を実現させた経験から、厳しい局面にある企業の本質的課題を見極め、実行可能な改革プランを策定する能力を養ってきました。

【職務経歴】
■ 株式会社Algomaticコンサルティング（2018年4月～現在）
○ 会社概要：従業員120名の総合経営コンサルティングファーム。製造業、小売業、サービス業を中心に年間100社以上の企業を支援。
○ 職務内容：シニアディレクター（2021年4月～）
・製造業を中心とした事業再生、成長戦略立案、M&A、事業承継等の総合的経営コンサルティングを担当
・10名のコンサルタントチームをマネジメントし、複数プロジェクトの同時進行を統括
・年間売上高5億円～100億円規模の中堅企業に対する経営改革プロジェクトを年間10～15件担当
○ 具体的な成果：
・自動車部品製造業の事業再生案件にて、赤字体質からの脱却を実現（2年間で営業利益率▲5%→+8%へ改善）
・家具製造業のDX戦略立案・実行支援により、生産性30%向上、リードタイム半減を達成
・建設業の事業承継プロジェクトにて、5年計画での円滑な経営移行を完遂し、企業価値を40%向上
○ 身につけたスキル：
・多業種にわたる経営課題解決能力と業界特性の理解
・中堅・中小企業特有の組織文化を考慮した変革マネジメント手法
・財務分析と事業戦略の統合的アプローチ手法

■ 株式会社Algomaticビジネスアドバイザリー（2013年7月～2018年3月）
○ 会社概要：従業員60名のM&A・事業再生専門のコンサルティングファーム。年間30～40件のM&A案件を手掛ける。
○ 職務内容：マネージャー（2015年10月～2018年3月）
・M&A案件のデューデリジェンス、企業価値評価、スキーム立案、PMI支援を担当
・事業再生案件における財務分析、事業計画策定、金融機関交渉を主導
・5名のチームをリードし、複数案件の同時進行管理を実施
○ 具体的な成果：
・食品製造業のM&A案件において、適切な企業価値評価と交渉戦略の立案により買収価格を当初想定から20%削減
・アパレル小売業の事業再生にて、不採算店舗の整理と在庫管理改革により、キャッシュフローを6か月で黒字化
・製造業5社のM&A支援を成功に導き、顧客満足度調査で5段階中4.8の高評価を獲得
○ 身につけたスキル：
・M&Aにおける企業価値評価と交渉戦略立案能力
・財務DD・事業DDの高度な分析手法
・事業再生における金融機関対応と交渉力

■ 株式会社Algomaticアドバイザーズ（2011年4月～2013年6月）
○ 会社概要：従業員25名の中小企業向け経営コンサルティング会社。主に飲食・小売業の企業を支援。
○ 職務内容：コンサルタント
・中小企業向け経営改善計画策定支援
・資金繰り改善、収益性向上施策の立案と実行支援
・管理会計システム構築支援
○ 具体的な成果：
・飲食チェーン（20店舗）の収益改善プロジェクトにて、原価率を5%低減、人件費率を3%改善
・小売業の在庫管理システム導入支援により、在庫回転率30%向上、欠品率50%削減を実現
・若手コンサルタント3名の育成を担当し、全員が1年以内に単独でプロジェクト遂行可能なレベルに成長
○ 身につけたスキル：
・中小企業の経営課題に対する実践的解決手法
・現場主義に基づく業務改善アプローチ
・管理会計システム構築と活用ノウハウ

【受賞・表彰歴】
・2022年 株式会社Algomaticコンサルティング 「年間MVPコンサルタント」受賞（年間最高売上と顧客満足度の両立）
・2020年 一般社団法人日本経営コンサルタント協会 「ベストプラクティス賞」受賞（製造業DX推進事例）
・2019年 経済産業省主催 「中小企業支援優良事例」選出（事業承継支援プロジェクト）
・2017年 株式会社Algomaticビジネスアドバイザリー 「イノベーション賞」受賞（M&A支援における新手法開発）

【資格】
・中小企業診断士（2013年3月取得）
・公認会計士（2010年12月登録）
・事業再生アドバイザー（2015年5月取得）
・M&Aスペシャリスト（2016年8月取得）
・経営革新等支援機関認定コンサルタント（2014年4月登録）
・DX推進認定コンサルタント（2021年9月取得）

【マネジメント経験】
・株式会社Algomaticコンサルティングにて10名規模のコンサルティングチームをマネジメント（2021年4月～現在）
・年間15～20件のプロジェクトマネジメントを統括し、品質管理、進捗管理、リソース配分を実施
・部門の年間売上目標（8億円）達成に向けた営業戦略立案と実行
・コンサルタントの育成プログラム開発と実施（年間5名の新人育成を担当）
・株式会社Algomaticビジネスアドバイザリーにて5名のプロジェクトチームをマネジメント（2015年～2018年）
・M&A案件における複数のデューデリジェンスチームのリード経験

【語学力】
・英語：ビジネスレベル（TOEIC 850点）
・実務での使用経験：外資系企業とのM&A交渉、海外DD調査、英文契約書の精査
・海外クライアント（欧米・アジア）とのミーティング対応、プレゼンテーション経験あり
` as const;
